import {useWebshop as useWebshopBase} from '../../nuxt-base/composables/useWebshop.js';

export function useWebshop(opts = {}) {
	const webshop = useWebshopBase(opts);
	const nuxtApp = useNuxtApp();
	const token = useToken();
	const customer = useState('customer', () => null);
	const originalFetchCart = webshop.fetchCart;
	const originalFetchCustomer = webshop.fetchCustomer;
	const generation = () => nuxtApp._bigbangKeycloak?.generation || 0;

	webshop.fetchCart = async options => {
		const started = generation();
		const response = await originalFetchCart(options);
		if (started === generation()) return response;
		// A response started before logout must not restore the old customer's cart.
		webshop.cart.value = null;
		await nuxtApp._bigbangKeycloak?.logout;
		return token.get() ? originalFetchCart(options) : null;
	};
	webshop.fetchCustomer = async (...args) => {
		const started = generation();
		const response = await originalFetchCustomer(...args);
		if (started === generation()) return response;
		customer.value = null;
		return null;
	};
	return webshop;
}
